import axios from 'axios'
import {
  ACATS_CASE_STATUS_API,
  ACATS_CASE_ACCEPT_API,
  ACATS_CASE_REJECT_API,
  WITH_CREDENTIALS_CONFIG,
} from './constants'

const getCaseStatus = (acatId: string) => {
  return axios.get(ACATS_CASE_STATUS_API(acatId), WITH_CREDENTIALS_CONFIG)
}

const putCaseAccept = (processingCaseId: number) => {
  return axios.put(
    ACATS_CASE_ACCEPT_API(processingCaseId),
    {},
    WITH_CREDENTIALS_CONFIG
  )
}

const putCaseReject = (
  processingCaseId: number,
  reason: string,
  comment: string
) => {
  return axios.put(
    ACATS_CASE_REJECT_API(processingCaseId),
    { reason, comment },
    WITH_CREDENTIALS_CONFIG
  )
}

export { getCaseStatus, putCaseAccept, putCaseReject }
